import React from "react";
import PropTypes from "prop-types";
import styles from "./PromotionItemCard.module.css";

/**
 * A single promotion row for the Promotions catalog. Unlike the Store's
 * ProductItemCard (which has Image / Title / SKU / Type / Status / Actions),
 * promotions only need four columns — Image, Title/Info, Type, Status — plus the
 * action column. Kept separate so the two catalogs can diverge freely.
 */
export function PromotionItemCard({ promotion, actionColWidth, children }) {
  const { image, name, date, summary, type, statusLabel } = promotion;
  return (
    <article
      className={styles.row}
      style={{ "--action-col-width": actionColWidth }}
    >
      <div className={styles.imageCell}>
        {image ? (
          <img src={image} alt={name} />
        ) : (
          <div className={styles.imagePlaceholder}>No image</div>
        )}
      </div>

      <div className={styles.detailsCell}>
        <h4 className={styles.name}>{name}</h4>
        {date && <p className={styles.date}>Updated {date}</p>}
        {summary && <p className={styles.summary}>{summary}</p>}
      </div>

      <div className={styles.typeCell}>{type}</div>
      <div className={styles.statusCell}>
        <span className={styles.statusLabel}>{statusLabel}</span>
      </div>
      <div className={styles.actionCell}>{children}</div>
    </article>
  );
}

PromotionItemCard.propTypes = {
  promotion: PropTypes.shape({
    id: PropTypes.string,
    image: PropTypes.string,
    name: PropTypes.string,
    date: PropTypes.string,
    summary: PropTypes.string,
    type: PropTypes.string,
    statusLabel: PropTypes.string,
  }).isRequired,
  actionColWidth: PropTypes.string,
  children: PropTypes.node,
};

PromotionItemCard.defaultProps = {
  actionColWidth: "140px",
  children: null,
};

export default PromotionItemCard;
